import React from "react";

const FirstPremierLending = () => {
  return (
    <div style={{ padding: 0, margin: 0 }}>
      <iframe
        src="https://firstpremierlending.livauto.com/reports.php?e4673-be992dvd-420510b-40deb166-894a"
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
        title="First Premier Lending Reports"
      ></iframe>
    </div>
  );
};

export default FirstPremierLending;
